import { API_MID_TAG, API_PROXY_TAG } from '../constants';
import { getFrontApiPath } from '../helpers/http';
import requestBaseInstance from './request-base';

class HttpClassPortalFront {
  static MAX_AGE_FOR_LOCALE_COOKIE = 180 * 24 * 3600 * 1000; // 180天
  static instance;

  static getInstance() {
    if (!HttpClassPortalFront.instance) {
      HttpClassPortalFront.instance = new HttpClassPortalFront();
    }
    return HttpClassPortalFront.instance;
  }

  async call(action, data) {
    try {
      const fullPath = getFrontApiPath(action);
      return await requestBaseInstance.callBase({ fullPath, data });
    } catch (err) {
      throw err;
    }
  }

  // 请求主应用接口
  async fetchMid(action, data) {
    try {
      const fullPath = getFrontApiPath(action, API_MID_TAG); // 会加上/api/mid前缀标识符
      return await requestBaseInstance.callBase({ fullPath, data });
    } catch (err) {
      throw err;
    }
  }

  // 请求主应用代理接口 (注意调用时处理proxy配置)
  async fetchMidProxy(action, data) {
    try {
      const fullPath = getFrontApiPath(action, API_PROXY_TAG); // 会加上/api/mid/proxy前缀标识符
      return await requestBaseInstance.callBase({ fullPath, data });
    } catch (err) {
      throw err;
    }
  }
}

export default HttpClassPortalFront;
